import * as Yup from 'yup'

import { useEffect, useState } from "react"

import { IDateTimeProps } from './IDateTimeProps'
import { InputFieldHelper } from '../InputHelper'

export const useDateTimeValidationSchema = (props: IDateTimeProps) => {
    const [schema, setSchema] = useState<Yup.DateSchema>();

    useEffect(() => {
        const { label, placeholder, required, min, max } = props

        let schema = Yup.date()
        if (required)
            schema = schema.required();

        if (label)
            schema = schema.label(label);
        else if (placeholder)
            schema = schema.label(placeholder);

        if (min)
            schema = schema.min(min, (p) => `${p.label} field must be later than ${InputFieldHelper.toLocalDateString(p.min)}`);

        if (max)
            schema = schema.max(min, (p) => `${p.label} field must be at earlier than ${InputFieldHelper.toLocalDateString(p.max)}`);

        setSchema(schema)
        // eslint-disable-next-line
    }, [props])

    return schema
}
